module.exports = __webpack_public_path__ + "4a59c4225749e08f0a36d79c4dad7470.jpg";